import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledSidebar = styled(Layout.Sider)<{ originalTheme: any }>`
  &.ant-layout-sider {
    background: transparent;
    border-right: 1px solid ${props => props.originalTheme?.colors?.primary?.main?.divider};
  }

  &.ant-layout-sider-light {
    background: transparent;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ant-layout-sider-trigger {
    background: transparent;
    border-top: 1px solid ${props => props.originalTheme?.colors?.primary?.main?.divider};
    color: ${props => props.originalTheme?.colors?.secondary?.main?.text || '#000000'};
  }

  &.ant-layout-sider-collapsed {
    .ant-layout-sider-trigger {
      width: 80px;
    }
  }

  /* Logo container border bottom */
  .sidebar-logo {
    border-bottom: 1px solid ${props => props.originalTheme?.colors?.primary?.main?.divider};
    margin-bottom: 0;
    padding: 12px 16px;
    box-sizing: border-box;
  }

  /* Border bottom for all menu items and groups */
  .ant-menu-item-group-list {
    border-bottom: 1px solid ${props => props.originalTheme?.colors?.primary?.main?.divider};
  }

  /* Remove left padding from menu items */
  .ant-menu-item {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    color: ${props => props.originalTheme?.colors?.secondary?.main?.text};
  }

  :where(.ant-menu):not(.ant-menu-sub) > .ant-menu-item {
    border-bottom: 1px solid ${props => props.originalTheme?.colors?.primary?.main?.divider};
    border-radius: 0 !important;
    margin-left: 0 !important;
    width: 100% !important;
    padding-bottom: 1.5rem !important;
    padding-top: 1.5rem !important;
    margin-top: 0px;
  }

  &.ant-layout-sider-collapsed .ant-menu-item {
    padding-right: 0 !important;
    padding-left: 1rem !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .ant-menu-light .ant-menu-item-selected {
    background-color: ${props => props.originalTheme?.colors?.primary?.main?.filled};
    color: ${props => props.originalTheme?.colors?.primary?.main?.text};
  }
  .ant-menu .ant-menu-item-group .ant-menu-item-group-list .ant-menu-submenu-title {
    padding-left: 1rem !important;
  }
  .ant-menu-inline .ant-menu-sub.ant-menu-inline {
    padding-left: 1rem !important;
  }
`;
